import ISO_ADA from 'assets/canvasGraphis/iso_ada.json';
import ISO_DOUGLAS from 'assets/canvasGraphis/iso_douglas.json';
import ISO_KATNISS from 'assets/canvasGraphis/iso_katniss.json';
import ISO_RUST from 'assets/canvasGraphis/iso_rust.json';
import ISO_SKILLY from 'assets/canvasGraphis/iso_skilly.json';
import ISO_ELEMENT from 'assets/canvasGraphis/iso_element.json';

import TD_ADA from 'assets/canvasGraphis/td_ada.json';
import TD_DOUGLAS from 'assets/canvasGraphis/td_douglas.json';
import TD_KATNISS from 'assets/canvasGraphis/td_katniss.json';
import TD_RUST from 'assets/canvasGraphis/td_rust.json';
import TD_SKILLY from 'assets/canvasGraphis/td_skilly.json';
import TD_ELEMENT from 'assets/canvasGraphis/td_element.json';

export default function getFreecodeLazyImageData(image) {
  return (
    ISO_ELEMENT[0][image] ||
    TD_ELEMENT[0][image] ||
    ISO_ADA[0][image] ||
    ISO_DOUGLAS[0][image] ||
    ISO_KATNISS[0][image] ||
    ISO_RUST[0][image] ||
    ISO_SKILLY[0][image] ||
    TD_ADA[0][image] ||
    TD_DOUGLAS[0][image] ||
    TD_KATNISS[0][image] ||
    TD_RUST[0][image] ||
    TD_SKILLY[0][image]
  );
}
